.ADICWrapper
    position: fixed
    bottom: 0
    left: 0
    right: 0
    height: 0
    min-height: 0
    overflow: hidden
    z-index: 3
    border-radius: $globalSettingsRoundingLarge
    background: rgb($globalSettingsBackgroundPrimary)
    .ADICContainer
        width: 100%
        height: 100%
        display: flex
        flex-direction: column
        overflow: hidden

.ADICWrapperOpened
    height: calc(100% - 60px)
    padding: 20px 0

.ADICModal
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: rgb($globalSettingsFontTertiary)
    cursor: pointer
    animation: 0.2s ease-in-out 0s 1 openADICModal
    animation-fill-mode: forwards
    opacity: 0
    border-radius: $globalSettingsRoundingLarge

@keyframes openADICModal
    0%
        opacity: 0
    100%
        opacity: 0.6
